import { useCallback, useEffect, useState } from "react";
import i18next from "src/i18n/config";

import { showErrorToast } from "@shared/toasts/Toasts";

import { fetchClient, FetchClientParams } from "../api";

interface UseClientState {
    data: API.Workspace | null;
    loading: boolean;
}

export const useClient = (params: FetchClientParams | null) => {
    const [state, setState] = useState<UseClientState>({
        data: null,
        loading: false,
    });

    const fetchData = async () => {
        if (!params) {
            return;
        }

        setState((prev) => ({ ...prev, loading: true }));
        const data = await fetchClient(params);
        setState({ data, loading: false });
    };

    useEffect(() => {
        if (!params) {
            setState({ data: null, loading: false });
            return;
        }

        const loadData = async () => {
            try {
                await fetchData();
            } catch (error) {
                setState((prev) => ({
                    ...prev,
                    loading: false,
                }));
                const err = error as Error;
                showErrorToast(err.message || i18next.t("pages:clientsOverviewPage.toast.fetchClientError"));
            }
        };

        loadData();
    }, [params?.workspaceId, params?.clientId]);

    const refetch = useCallback(async () => {
        if (!params) {
            return;
        }

        try {
            await fetchData();
        } catch (error) {
            setState((prev) => ({
                ...prev,
                loading: false,
            }));
            const err = error as Error;
            showErrorToast(err.message || i18next.t("pages:clientsOverviewPage.toast.fetchClientError"));
        }
    }, [params]);

    return {
        ...state,
        refetch,
    };
};
